import { ConditionalValue, Image } from '@chakra-ui/react';
import { CssProperties } from '@chakra-ui/react/dist/types/styled-system/css.types';
import { UtilityValues } from '@chakra-ui/react/dist/types/styled-system/generated/prop-types.gen';
import { AnyString, CssVars } from '@chakra-ui/react/dist/types/styled-system/generated/system.gen';
import { useMemo } from 'react';
import { BsZoomIn } from 'react-icons/bs';
import { useImagePreview } from '@/hooks';
import { images } from '@/utils';

interface IProps {
  image?: string;
  filePath?: string;
  width?: ConditionalValue<UtilityValues['width'] | CssVars | CssProperties['width'] | AnyString>;
  height?: ConditionalValue<
    UtilityValues['height'] | CssVars | CssProperties['height'] | AnyString
  >;
  radius?: string | number;
  hidePreview?: boolean;
}

function BaseImage(props: IProps) {
  const { toggleImagePreview } = useImagePreview();

  const url = useMemo(() => {
    if (!props.image) return images.noImage;
    if (props.image.indexOf('blob') === 0) return props.image;
    if (props.image.indexOf('http') === 0) return props.image;

    return props.image;
  }, [props.image]);

  return (
    <div
      onClick={
        !props.hidePreview
          ? (e) => {
              e.stopPropagation();
              toggleImagePreview(props.filePath || props.image);
            }
          : undefined
      }
      style={{
        cursor: !props.hidePreview ? 'pointer' : undefined,
        width: `${props.width || '100px'}`,
        height: `${props.height || props.width || '100px'}`,
      }}
      className="base-img"
    >
      {!props.hidePreview && !!props.image && (
        <div className="hover-zoom" style={{ borderRadius: props.radius || '6px' }}>
          <BsZoomIn />
        </div>
      )}

      <Image
        width={props.width || '100px'}
        height={props.height || props.width || '100px'}
        rounded={props.radius ? 'unset' : 'lg'}
        src={url}
        alt="3D Image"
        borderRadius={props.radius}
        className="d-block m-auto"
      />
    </div>
  );
}

export { BaseImage };
